/**
 * Roulette seed derivation — Plan 08-03 Task 2.
 *
 * seed = donationEventId (1회전 = 1 후원 이벤트).
 * 동일 eventId → 동일 회전수 / 동일 winner index.
 */
import { createSeededRng, type SeededRng } from '../seeded-rng.js';

export function createRouletteRng(donationEventId: string): SeededRng {
  return createSeededRng(donationEventId);
}
